import React from "react";
import { TransactionStatusTag } from "../../components/common/registerUtils";
import { beautify } from "../../utils/helpers";

export const useUSSDCustomerTransactions = () => {
  const tableColumns = () => [
    { id: "customer_ref", header: "Customer Ref", filter: { type: "text" } },
    { id: "customer_name", header: "Customer Name", filter: { type: "text" } },
    {
      id: "customer_token",
      header: "Customer Token",
      filter: { type: "text" },
    },
    { id: "customer_area", header: "Area", filter: { type: "text" } },
    { id: "customer_region", header: "Region", filter: { type: "text" } },
    { id: "customer_phone", header: "Phone", filter: { type: "text" } },
    { id: "amount", header: "Amount", filter: { type: "text" } },

    {
      id: "callback_status",
      header: "Callback Status",
      filter: { type: "select" },
    },
    { id: "transact_id", header: "Transaction ID", filter: { type: "text" } },
    { id: "yoya_id", header: "Yoya ID", filter: { type: "text" } },
    { id: "provider_ref", header: "Provider Ref", filter: { type: "text" } },
    { id: "merchant_code", header: "Merchant Code", filter: { type: "text" } },
    { id: "telecom", header: "Telecom", filter: { type: "text" } },
    { id: "ussd_agent_code", header: "Agent Code", filter: { type: "text" } },
    { id: "smssent", header: "SMS Sent", filter: { type: "select" } },
    { id: "reason", header: "Reason", filter: { type: "text" } },
    { id: "callback_ref", header: "Callback Ref", filter: { type: "text" } },
    {
      id: "callback_reason",
      header: "Callback Reason",
      filter: { type: "text" },
    },
    { id: "created_at", header: "Created At", filter: { type: "text" } },
  ];

  const tableData = (data: any[]) =>
    data?.map((item: any) => ({
      ...item,
      customer_name: beautify(item?.customer_name),
      customer_area: beautify(item?.customer_area),

      callback_status: <TransactionStatusTag status={item?.callback_status} />,
      created_at: new Date(item?.created_at).toLocaleString(),
    })) || [];

  return {
    tableColumns,
    tableData,
  };
};
